/**
 * Currency formatting and parsing utilities
 * Used by forms, display components, and calculations.
 */

/** Parse user input (e.g. "$1,234") to numeric string for storage. Clean numeric string or '' if invalid. */
export function parseCurrency(value: string | number | null | undefined): string {
    if (!value || value === '') return '';
    const cleanValue = String(value).replace(/[$,\s]/g, '');
    const numValue = parseFloat(cleanValue);
    return isNaN(numValue) ? '' : numValue.toString();
}

/** Format a number for display (e.g. 1234 -> "$1,234"). */
export function formatCurrency(value: number | string | null | undefined): string {
    if (value === null || value === undefined || isNaN(Number(value))) {
        return '$0';
    }
    const num = typeof value === 'number' ? value : parseFloat(value) || 0;
    const roundedValue = Math.round(num);
    return `${roundedValue < 0 ? '-' : ''}$${Math.abs(roundedValue).toLocaleString()}`;
}

/** Format value for display inside an input field (handles empty). */
export function formatCurrencyForInput(value: number | string | null | undefined): string {
    if (value === '' || value === undefined || value === null) return '';
    const n = Number(value);
    if (isNaN(n)) return '';
    return '$' + n.toLocaleString('en-AU', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}
